module.exports = __webpack_public_path__ + "static/media/sign-in-cloud.babfe9cb.png";